import React, { useEffect, useState } from 'react'
import { IToast } from '../../../../interfaces/components/IToast';
import RunEmailsToCheck from '../details/RunEmailsToCheck';
import UploadFilesModal from '../modals/UploadFilesModal';
import DiscrepancyModal from '../modals/DiscrepancyModal';
import Button from '../../../../shared/button';
import Toast from '../../../../shared/toast';

const CashTab = () => {
    const [showToast, setShowToast] = useState<IToast | null>()
    const [showFilesModal, setShowFilesModal] = useState<boolean>()
    const [response, setResponse] = useState<any>();

    const onOpenFilesModal = () => {
        setShowFilesModal(true)
    }

    const onCloseModal = () => {
        setShowFilesModal(false)
        setResponse(undefined)
    }

    return (
        <div>
            <div className='my-10 flex flex-col md:flex-row justify-center'>
                <Button
                    label={'Upload Files To Compare'}
                    className='btn-primary-rounded-less mr-4 mb-5 md:mb-0'
                    onClickButton={onOpenFilesModal}
                />
                <RunEmailsToCheck
                    setResponse={setResponse}
                />
            </div>
            {showFilesModal &&
                <UploadFilesModal
                    openModal={showFilesModal}
                    type={'cash'}
                    handleCloseModal={onCloseModal}
                />
            }
            {response &&
                <DiscrepancyModal
                    openModal={!!response}
                    data={response}
                    handleCloseModal={onCloseModal}
                />
            }
            {showToast?.message &&
                <Toast
                    type={showToast?.type}
                    text={showToast?.message}
                    onHandleCloseToast={() => setShowToast(null)}
                />
            }
        </div>
    )
}
export default CashTab;